import { useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UseI18n } from '../../../../../../common/hooks/useI18n'
import { Element } from '../../../../../../common/html/element'
import { MAX_CONDITION } from '../../../../common/constant'
import { ErrorMessage } from '../../../../common/errorMessage'
import { getCurrentTime } from '../../../../common/helper'
import { Input } from '../../../../common/input'
import { selectScreeningIndicatorById } from '../../../../common/store/slice'
import { changeCriteria, selectCriteria } from '../../../store/slice'
import { DeleteAddButtons } from '../deleteAddButtons'
import classes from './index.module.scss'

export const NumberRangeItem = ({
  criteriaGroup,
  screeningIndicatorId,
  conditionId,
  hasAddBtn,
  conditionsLength,
  isFloatNumber,
}) => {
  const dispatch = useDispatch()

  const timeoutRef = useRef()

  const maxMultiple =
    useSelector(
      selectScreeningIndicatorById(screeningIndicatorId, 'maxMultiple'),
    ) || MAX_CONDITION

  const conditionData = useSelector(
    selectCriteria([criteriaGroup, screeningIndicatorId, 'data', conditionId]),
  )

  const [isShowMaxMessage, setIsShowMaxMessage] = useState(false)

  const onAddBtnClick = () => {
    if (conditionsLength >= maxMultiple) {
      setIsShowMaxMessage(true)
      clearTimeout(timeoutRef.current)
      timeoutRef.current = setTimeout(() => {
        setIsShowMaxMessage(false)
      }, 3000)
      return
    }

    const id = getCurrentTime()
    dispatch(
      changeCriteria({
        path: [criteriaGroup, screeningIndicatorId, 'data', id],
        data: { id, from: '', to: '' },
      }),
    )
  }

  const onDeleteBtnClick = () => {
    if (conditionsLength === 1) {
      dispatch(
        changeCriteria({
          path: [criteriaGroup, screeningIndicatorId, 'data', conditionId],
          data: { id: conditionId, from: '', to: '' },
        }),
      )
    } else {
      dispatch(
        changeCriteria({
          path: [criteriaGroup, screeningIndicatorId, 'data', conditionId],
          data: undefined,
        }),
      )
    }
  }

  const resetError = () => {
    if (conditionData.error) {
      dispatch(
        changeCriteria({
          path: [
            criteriaGroup,
            screeningIndicatorId,
            'data',
            conditionId,
            'error',
          ],
          data: undefined,
        }),
      )
    }
  }

  const onFromChange = (value) => {
    resetError()
    dispatch(
      changeCriteria({
        path: [
          criteriaGroup,
          screeningIndicatorId,
          'data',
          conditionId,
          'from',
        ],
        data: value,
      }),
    )
  }

  const onToChange = (value) => {
    resetError()
    dispatch(
      changeCriteria({
        path: [criteriaGroup, screeningIndicatorId, 'data', conditionId, 'to'],
        data: value,
      }),
    )
  }

  return (
    <>
      <Element className={classes.item}>
        <Input
          isNumber
          isFloatNumber={isFloatNumber}
          placeholder={UseI18n('screening.FROM')}
          value={conditionData.from}
          onChange={onFromChange}
          autoFocus
          wrapperClassname="flex1 minW0 mr1"
        />
        <Input
          isNumber
          isFloatNumber={isFloatNumber}
          placeholder={UseI18n('screening.TO')}
          value={conditionData.to}
          onChange={onToChange}
          wrapperClassname="flex1 minW0"
        />
        <DeleteAddButtons
          showAddBtn={hasAddBtn}
          onAddBtnClick={onAddBtnClick}
          onDeleteBtnClick={onDeleteBtnClick}
        />
      </Element>
      {conditionData.error && <ErrorMessage value="screening.REQUIRED_MESS" />}
      {hasAddBtn && isShowMaxMessage && (
        <ErrorMessage
          value="screening.MAX_CONDITION_MESS"
          max={maxMultiple}
          className="mt1"
        />
      )}
    </>
  )
}
